export enum EstadosTransferencia {
  ESPERANDO_DEPOSITO = 'ESPERANDO_DEPOSITO',
  POR_PROCESAR = 'POR_PROCESAR',
  PROCESANDO_BINANCE = 'PROCESANDO_BINANCE',
  EN_PROCESO = 'EN_PROCESO',
  ENVIADA = 'ENVIADA',
  ENVIADO = 'ENVIADO',
  RECHAZADO = 'RECHAZADA',
  CANCELADO = 'CANCELADO',
  ANULADA = 'ANULADA',
}
